var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMomentjs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128,256 C198.692448,256 256,198.692448 256,128 C256,57.307552 198.692448,0 128,0 C57.307552,0 0,57.307552 0,128 C0,198.692448 57.307552,256 128,256 L128,256 Z M128,236.8 C67.9114192,236.8 19.2,188.088581 19.2,128 C19.2,67.9114192 67.9114192,19.2 128,19.2 C188.088581,19.2 236.8,67.9114192 236.8,128 C236.8,188.088581 188.088581,236.8 128,236.8 L128,236.8 Z",
    fill: "#376660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,230.4 C184.553958,230.4 230.4,184.553958 230.4,128 C230.4,71.4460416 184.553958,25.6 128,25.6 C71.4460416,25.6 25.6,71.4460416 25.6,128 C25.6,184.553958 71.4460416,230.4 128,230.4 L128,230.4 Z M128,32 C124.465378,32 121.6,34.8796721 121.6,38.443811 L121.6,121.6 L76.7809926,121.6 C73.2568678,121.6 70.4,124.440735 70.4,128 C70.4,131.534622 73.3162522,134.4 76.7705446,134.4 L134.4,134.4 L134.4,38.4055786 C134.4,34.8678752 131.559265,32 128,32 L128,32 Z",
    fill: "#529990"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomentjs);
export default __webpack_public_path__ + "static/media/momentjs.80ca82a8.svg";
export { ForwardRef as ReactComponent };